module.exports = __webpack_public_path__ + "static/media/homepage_curriculum_scroll.1a343d2a.png";